import React from 'react';
import { Container, Eyebrow, Section } from '../components/ui/Section';
import { PhotoFrame } from '../components/ui/PhotoFrame';
import { ButtonExternal, ButtonLink } from '../components/ui/Button';
import { LeaderCard } from '../components/about/LeaderCard';
import { DoodleStar, DoodleUnderline } from '../components/brand/Doodles';
import { leadership } from '../data/leadership';
import { galleryPhotos } from '../data/photos';
import { externalLinks } from '../data/site';
const schools = ['University of Central Florida', 'Valencia College', 'Seminole State', 'Full Sail University'];
const areas = [{
  title: 'Worship',
  copy: 'Sing, pray, and hear a Bible-centered message together.'
}, {
  title: 'Bible studies',
  copy: 'Study Scripture in smaller groups and ask honest questions.'
}, {
  title: 'Community and fellowship',
  copy: 'Share meals, hang out, and build friendships that last past one semester.'
}, {
  title: 'Evangelism and campus outreach',
  copy: 'Meet students across campus and share the hope of the Gospel.'
}, {
  title: 'Service',
  copy: 'Serve the campus and the surrounding community together.'
}, {
  title: 'Missions',
  copy: 'Take part in mission opportunities offered during the year.'
}, {
  title: 'Intramural sports and recreation',
  copy: 'Play intramurals and join recreational nights like pickleball.'
}];
const pillars = [{
  title: 'Bring In',
  copy: 'Welcome students and help them encounter the Gospel in a genuine Christian community.'
}, {
  title: 'Build Up',
  copy: 'Help students grow in faith, friendship, service, and leadership.'
}, {
  title: 'Send Out',
  copy: 'Equip students to live out their faith and serve on campus and beyond.'
}];
export function About() {
  return <>
      {/* Hero */}
      <Section className="bcm-paper overflow-hidden py-14 sm:py-20" labelledBy="about-heading" data-id="element-392" data-mp="2w7x9ur6c42iv">
        <Container className="grid items-start gap-10 lg:grid-cols-[1.05fr_0.8fr] lg:gap-14" data-id="element-393" data-mp="2r9dj8dgsq2k6">
          <div data-id="element-394" data-mp="1ovxu9wrqyyea">
            <Eyebrow data-id="element-395" data-mp="1ow7jhi4yx1ix">About UCF BCM</Eyebrow>
            <h1 id="about-heading" className="mt-4 max-w-2xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-brand-navy sm:text-6xl" data-id="element-396" data-mp="1svyiua8k8pz2">
              A place to belong, ask questions, and grow
            </h1>
            <DoodleUnderline className="mt-3 h-3.5 w-44" color="var(--bcm-yellow)" data-id="element-397" data-mp="22o47pb3imra1" />
            <p className="mt-6 max-w-xl font-sans text-[17px] leading-relaxed text-ink" data-id="element-398" data-mp="27kura8ej4507">
              BCM is a place for students to explore the claims of Jesus Christ and experience the
              excitement of answering the call to follow Him.
            </p>
            <p className="mt-4 max-w-xl font-sans text-[17px] leading-relaxed text-ink" data-id="element-399" data-mp="2ljudzaihe9tq">
              BCM stands for Baptist Collegiate Ministries, but you do not need to be Baptist—or even
              Christian—to find a home here. Students come from many denominations, religious
              backgrounds, schools, and life experiences. Everyone is welcome.
            </p>
          </div>
          <div className="relative" data-id="element-400" data-mp="ewd681idkj7k">
            <DoodleStar className="absolute -left-4 -top-5 h-10 w-10" color="var(--bcm-pink)" data-id="element-401" data-mp="evbxw4squatj" />
            <PhotoFrame photo={galleryPhotos[1]} ratio="aspect-[4/5]" rotate="-rotate-1" data-id="element-402" data-mp="9xtmm7r97jid" />
          </div>
        </Container>
      </Section>

      {/* Who BCM serves */}
      <Section className="bg-[#fffdf6] py-14 sm:py-18" labelledBy="about-serves-heading" data-id="element-403" data-mp="12l6acl95hxd9">
        <Container className="grid gap-8 lg:grid-cols-[1fr_0.9fr] lg:gap-14" data-id="element-404" data-mp="xmuzq8b17itz">
          <div data-id="element-405" data-mp="snrt4jfel4jw">
            <h2 id="about-serves-heading" className="font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-4xl" data-id="element-406" data-mp="sn9y1q4h8wdk">
              Serving students across Central Florida
            </h2>
            <p className="mt-5 max-w-xl font-sans text-[17px] leading-relaxed text-ink" data-id="element-407" data-mp="3dflgxssv4fjq">
              UCF BCM primarily serves students at the University of Central Florida and also
              welcomes students from surrounding colleges, including Valencia College, Seminole
              State, and Full Sail University.
            </p>
          </div>
          <ul className="grid gap-3 sm:grid-cols-2 lg:content-start" data-id="element-408" data-mp="r6ktnfronnqd">
            {schools.map(school => <li key={school} className="rounded-2xl border-2 border-brand-navy bg-brand-tan px-5 py-4 font-display text-base font-semibold text-brand-navy" data-id="element-409" data-mp="w5xlyg1bpn0c">
                {school}
              </li>)}
          </ul>
        </Container>
      </Section>

      {/* What BCM does */}
      <Section className="bg-brand-blue py-14 sm:py-18" labelledBy="about-does-heading" data-id="element-410" data-mp="1aw4xscwts7s2">
        <Container data-id="element-411" data-mp="1exgs2vqn9h6l">
          <h2 id="about-does-heading" className="font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-navy sm:text-5xl" data-id="element-412" data-mp="3vk14t7b6j3b6">
            Faith lived out together
          </h2>
          <p className="mt-4 max-w-2xl font-sans text-[16px] leading-relaxed text-ink" data-id="element-413" data-mp="3s1ao1ace4epd">
            These are the ways BCM students gather and serve throughout the year. Not every activity
            happens every week — check the Events page for what is currently scheduled.
          </p>
          <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-414" data-mp="v96cixx6mur">
            {areas.map(area => <li key={area.title} className="rounded-[22px] border-2 border-brand-navy bg-white p-6" data-id="element-415" data-mp="39cnkiw9v3xdw">
                <h3 className="font-display text-lg font-bold leading-snug text-brand-navy" data-id="element-416" data-mp="34dkdj6abnh3a">
                  {area.title}
                </h3>
                <p className="mt-2 font-sans text-[15px] leading-relaxed text-ink" data-id="element-417" data-mp="3j38h6e5z6ru6">{area.copy}</p>
              </li>)}
          </ul>
        </Container>
      </Section>

      {/* Mission */}
      <Section className="on-dark bg-brand-navy py-14 text-white sm:py-20" labelledBy="about-mission-heading" data-id="element-418" data-mp="2qirsxtfkrapu">
        <Container data-id="element-419" data-mp="3ba5dq3hc8lll">
          <p className="font-meta text-xs font-semibold uppercase tracking-[0.2em] text-brand-blue" data-id="element-420" data-mp="3baouhgv953y1">
            Our Mission
          </p>
          <h2 id="about-mission-heading" className="mt-3 font-display text-4xl font-extrabold tracking-tight sm:text-5xl" data-id="element-421" data-mp="3fa7e89bc78za">
            Bring in. Build up. Send out.
          </h2>
          <ul className="mt-10 grid gap-8 sm:grid-cols-3" data-id="element-422" data-mp="3p3o9lhr4gw52">
            {pillars.map(pillar => <li key={pillar.title} className="border-t-4 border-brand-yellow pt-5" data-id="element-423" data-mp="2sde1ge07r6r1">
                <h3 className="font-display text-2xl font-bold text-brand-blue" data-id="element-424" data-mp="2wd69mplp3avv">{pillar.title}</h3>
                <p className="mt-2 font-sans text-[16px] leading-relaxed text-white" data-id="element-425" data-mp="31aob5uxduntu">
                  {pillar.copy}
                </p>
              </li>)}
          </ul>
        </Container>
      </Section>

      {/* Location */}
      <Section className="bcm-paper py-14 sm:py-18" labelledBy="about-location-heading" data-id="element-426" data-mp="lklco07t0ye6">
        <Container data-id="element-427" data-mp="262w0w785pemq">
          <h2 id="about-location-heading" className="font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-4xl" data-id="element-428" data-mp="2635jvausalix">
            Where BCM meets
          </h2>
          <p className="mt-5 max-w-2xl font-sans text-[17px] leading-relaxed text-ink" data-id="element-429" data-mp="1wc14ia174ynk">
            During the school year, BCM meets Thursdays at 7:30 PM. Most weeks, worship is held on
            the third floor of the UCF Student Union in Cape Florida Ballroom, Room 316. Check the
            Events page or Instagram for the latest location.
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:flex-wrap" data-id="element-430" data-mp="1de8f8ajhwn8n">
            <ButtonLink to="/events" data-id="element-431" data-mp="1dgb2wnx6e4a7">View Events</ButtonLink>
            <ButtonExternal href={externalLinks.studentUnion} variant="secondary" data-id="element-432" data-mp="18g6ull6f8fv2">
              UCF Student Union Directions
            </ButtonExternal>
            <ButtonExternal href={externalLinks.capeFloridaBallroom} variant="secondary" data-id="element-433" data-mp="32t52jy4nf0f8">
              Cape Florida Ballroom Information
            </ButtonExternal>
          </div>
        </Container>
      </Section>

      {/* Leadership */}
      <Section className="bg-[#fffdf6] py-14 sm:py-18" labelledBy="about-leaders-heading" data-id="element-434" data-mp="2glu8bualsujm">
        <Container data-id="element-435" data-mp="22wa74swo85cf">
          <h2 id="about-leaders-heading" className="font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-4xl" data-id="element-436" data-mp="22uz6v32fpfq2">
            Meet the BCM leadership team
          </h2>
          <p className="mt-4 max-w-2xl font-sans text-[16px] leading-relaxed text-ink" data-id="element-437" data-mp="1szdy8m2v1h7c">
            These are the students and staff serving BCM this year. Reach out any time — someone is
            always glad to answer a question.
          </p>
          {/*
            INTERNAL CONTENT NOTE (not rendered): leader photographs are expected
            before the fall launch. Add each hosted URL to data/leadership.ts.
           */}
          <ul className="mt-9 grid grid-cols-2 gap-4 md:grid-cols-5" data-id="element-438" data-mp="3icr7mpptxvfb">
            {leadership.map((leader, index) => <li key={leader.id} data-id="element-439" data-mp="16pxgx71z3hvu" data-mpi={index}>
                <LeaderCard leader={leader} index={index} data-id="element-440" data-mp="16mt4jmectfu3" />
              </li>)}
          </ul>
          <div className="mt-8" data-id="element-441" data-mp="12l7mlmmyqbd1">
            <ButtonExternal href={externalLinks.getConnectedForm} variant="secondary" data-id="element-442" data-mp="1gf8nalxh68g1">
              Contact a BCM Leader
            </ButtonExternal>
          </div>
        </Container>
      </Section>

      {/* Worship team */}
      <Section className="bg-brand-blue py-14 sm:py-18" labelledBy="about-worship-heading" data-id="element-443" data-mp="1qbk15gcpr6cl">
        <Container className="grid items-center gap-10 lg:grid-cols-[0.9fr_1fr] lg:gap-14" data-id="element-444" data-mp="1lcqnnnxfffcf">
          <div data-id="element-445" data-mp="1zdt7rv4v2fkp">
            <h2 id="about-worship-heading" className="font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-4xl" data-id="element-446" data-mp="1zc9w6hu5gsp9">
              Worship at BCM
            </h2>
            <p className="mt-5 font-sans text-[17px] leading-relaxed text-ink" data-id="element-447" data-mp="4zscfk8isapd">
              BCM worship nights give students space to worship together, hear a Bible-centered
              message, and build community.
            </p>
          </div>
          {/*
            Placeholder only. A new worship-team photo is expected; do not reuse an
            outdated worship-team photo unless the content owner selects it.
           */}
          <div className="rounded-[24px] border-2 border-dashed border-brand-navy bg-brand-tan p-8 text-center" data-id="element-448" data-mp="2yehvrf2lol1t">
            <p className="font-display text-xl font-bold text-brand-navy" data-id="element-449" data-mp="3v4qr6o8i1alv">
              New worship team photo coming soon
            </p>
            <p className="mt-2 font-meta text-[13px] text-ink" data-id="element-450" data-mp="3r3p0wwwk88w1">
              This frame is reserved for a current photo of the BCM worship team.
            </p>
          </div>
        </Container>
      </Section>
    </>;
}